export class MedicoPlanoSaude {
    id:string;
    codigo:string;
    plano_saude:string;
    codigo_plano_saude:string;
    plano_saude_id:string;
}
